import React from 'react'
import Typography from '@material-ui/core/Typography';

import Link from "../components/Link"
import Image from "../components/image"
import SEO from "../components/seo"

function Home(props) {

    return (
        <>
            <SEO title="Home" />
            <Typography variant="h5"  gutterBottom>
            Welcome to Deep Questions
            </Typography>
            <div style={{ maxWidth: `500px`, marginBottom: `1.45rem` }}>
                <Image />
            </div>
            <Typography variant="h6" gutterBottom>
                Get ready to start learning!
            </Typography>
            <Typography variant="body1" gutterBottom>
                Here you will find tools powered by AI that
                will help you learn any subject.
            </Typography>
            <Typography variant="body1" gutterBottom>
                Log in, and start making a <Link to="/app/summary">summary</Link> from a text,
                or maybe generate <Link to="/app/questions">multiple-choice questions</Link>.
            </Typography>
        </>
    )
}

export default Home;